import { InvoiceCard } from "@/components/invoice/InvoiceCard";
import { EmptyState } from "./EmptyState";

interface Invoice {
  id: string;
  invoice_number: string;
  file_path: string;
  amount: number;
  due_date: string;
  status: string;
  recipient_email: string;
}

interface InvoiceGridViewProps {
  invoices: Invoice[];
  selectedInvoices: string[];
  onSelect: (id: string) => void;
  onCheckboxChange: (checked: boolean, id: string) => void;
  filter: "all" | "scheduled" | "unscheduled" | "paid" | "unpaid" | "recipient";
}

export const InvoiceGridView = ({
  invoices,
  selectedInvoices,
  onSelect,
  onCheckboxChange,
  filter,
}: InvoiceGridViewProps) => {
  if (invoices.length === 0) {
    return <EmptyState filter={filter} />;
  }

  return (
    // <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6 w-full">

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {invoices?.map((invoice) => (
        <InvoiceCard
          key={invoice.id}
          invoice={invoice}
          isSelected={selectedInvoices.includes(invoice.id)}
          onSelect={onSelect}
          onCheckboxChange={onCheckboxChange}
        />
      ))}
    </div>
  );
};
